import React, { useEffect, useRef, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import { CopyIcon, InfoIcon } from "../utils/Icons";
import { bm_date, bm_time, getSaved, kbdEvent, mergeArraysByKey, parseToTime, removeByKey, requestClerkCode, requireLogin, showConfirm, updateOrdering } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Row from "../ui/Row";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Nav from "../ui/Nav";
import Divider from "../ui/Divider";
import { ROUTES } from "../utils/Routes";
import { useTabs } from "../hooks/useTabs";
import { createScreen } from "../hooks/createScreen";
import Select from "../ui/Select";
import { ENUMS } from "../utils/Enums";
import Button from "../ui/Button";
import { type } from "@testing-library/user-event/dist/type";
import Float from "../ui/Float";
import Tags from "../ui/Tags";
import CustomerFilter from "./CustomerFilter";
import DateField from "../ui/DateField";
import TimeField from "../ui/TimeField";
import dayjs from "dayjs";
import { FILTER } from "../utils/Struct";
import CustomerColumns, { getDefaultColumns } from "./CustomerColumns";

import { drawPicker } from "../popovers/Picker";
import DateInput from "../ui/DateInput";
import TimeInput from "../ui/TimeInput";
import SalesIn from "./report_filters/SalesIn";
import InvoicesBetween from "./report_filters/InvoicesBetween";
import Spin from "../ui/Spin";
import { useClickAway } from "../hooks/useClickAway";
import InventoryBetween from "./report_filters/InventoryBetween";
import { getSignal, setSignal } from "../App";
import Cookies from "js-cookie";
import FocusWrap from "../hooks/FocusWrap";
import Status from "../ui/Status";
export default function CustomerCustomEdit(props) {

    const { controller = "", route = "", callback = () => { }, signal = {}, edit = {}, setEdit = () => { }, groups = [], initIndex = "" } = props;

    // set-up 
    const [autoSave, setAutoSave] = useState(false);
    const [columnView, setColumnView] = useState(true);
    const sales_period_between = edit?.filters?.find(item => item.type === -5);
    const row_key = "report_id";

    const [columnsChanged, setColumnsChanged] = useState(false);
    // back btn
    useEffect(() => {
        let _s = getSignal();
        setSignal({ ..._s, show_back: true });
        return () => {
            let _s = getSignal();
            setSignal({ ..._s, show_back: false });
        };
    }, []);


    const sales_types = edit?.filters?.find(item => item.type === -7);
    const sales_types_string = sales_types?.value_1 || "S|F|T";

    const _date_from = (sales_period_between?.value_1) ? dayjs(sales_period_between?.value_1).unix() : "";
    const _date_from_time = (sales_period_between?.value_1 && sales_period_between?.value_1.includes(" ")) ? dayjs(sales_period_between?.value_1).valueOf() : "";
    const _date_to = (sales_period_between?.value_2) ? dayjs(sales_period_between?.value_2).unix() : "";
    const _date_to_time = (sales_period_between?.value_2 && sales_period_between?.value_2.includes(" ")) ? dayjs(sales_period_between?.value_2).valueOf() : "";

    // If the struct has no clerk, treat as new
    const is_new = (edit?.clerk === "");


    const default_sales_in = edit?.filters?.find(item => item.type === -5) || {
        "comparison": "",
        "filter_id": "",
        "ordering": 0,
        "type": -5,
        "value_1": dayjs().add(-1, "day").format("YYYY-MM-DD") + " 00:00:00",
        "value_2": dayjs().format("YYYY-MM-DD") + " 23:59:00",
        "where_type": "AND"
    }

    const default_invoices_between = edit?.filters?.find(item => item.type === -6) || {
        "comparison": "",
        "filter_id": "",
        "ordering": 0,
        "type": -6,
        "value_1": "",
        "value_2": "",
        "where_type": "AND"
    }

    const defaultTabs = [
        { set: "edit", label: "name", key: "name", value: edit?.name || "New Report" },
        { set: "edit", label: "group", key: "group", value: edit?.group || "Default" },
        { set: "filters", label: "filter_all", key: "filter_all", value: "" },
        { set: "filters", label: "filter_one", key: "filter_one", value: "" },
        { set: "filters", label: "filter_none", key: "filter_none", value: "" },
        { set: "index", label: "order_1", key: "order_1", value: edit?.order_1 || 0 },
        { set: "index", label: "order_2", key: "order_2", value: edit?.order_2 || 0 },
        { set: "index", label: "order_3", key: "order_3", value: edit?.order_3 || 0 },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, (is_new) ? "name" : "");



    const getDefaultValue = (_key) => {
        let _f = defaultTabs.find(item => item.key === _key);
        if (_f) {
            return _f.value;
        } else {
            return "";
        }
    }


    const filter_clickaway = useClickAway(() => {
        if (window.bm_state.value === ROUTES.CUSTOMER.FILTER) {
            setIndex("");
        }
    }, (["filter_all", "filter_one", "filter_none"].includes(index)))


    const filter_clickaway2 = useClickAway(() => {
        if (window.bm_state.value === ROUTES.CUSTOMER.FILTER) {

            if (is_new) {
                //callback(false);
            } else {
                addReport()
                //setIndex("");
            }

        }
    }, (["name", "group"].includes(index)))

    const filter_clickaway3 = useClickAway(() => {
        if (window.bm_state.value === ROUTES.REPORTS.COLUMNS) {
            setIndex("");
        }
    }, (["columns"].includes(index)))


    const addColumns = (_report) => {

        pubCall("report.purgeAndReplaceColumns", { report_id: _report?.[row_key], columns: edit.columns }, (_s, _r) => {
            if (_s) {
                showMessage("Report saved successfully");
                callback()
            } else {
                showError(_r);
            }
        })

    }




    const addReport = (_vals = {}, exit = true, index = "") => {



        requestClerkCode({
            bypass: (is_new) ? false : edit?.clerk,
            signal: { value: getSignal() },
            route: route, callback: (e) => {

                if (!e) {
                    setIndex("name");
                    return;
                }

                const { scope_type = getVal("scope_type"), group = getVal("group") } = _vals;

                let _obj = {
                    name: getVal("name"),
                    type: 3,
                    scope_type: 0,
                    group: group,
                    order_1: edit.order_1,
                    order_2: edit.order_2,
                    order_3: edit.order_3,
                    columns: (is_new) ? edit.columns : [],
                    cached_row_total: null,
                    date_changed: dayjs().unix(),
                    filters: edit.filters,
                    clerk: e,
                    report_id: edit?.[row_key] || "",
                }
                let _update = (_obj?.[row_key]) ? { report_id: _obj?.[row_key], report_info: _obj } : { new_report: _obj }

                pubCall((is_new) ? "report.addReport" : "report.editReport", _update, (_s, _r) => {
                    if (_s) {

                        if (is_new) {
                            props.refresh(_r);
                        }
                        
                        showMessage("Report parameters saved")
                        setEdit(_r);
                        if (exit) {
                            setIndex(index)

                        }
                    } else {
                        showError(_r);
                    }
                })

            }
        })

    }

    // useEffect(() => {
    //     const actions = [
    //         { key: KBD.ESCAPE, action: (e) => { callback(false) } },




    //     ];
    //     const cleanup = listen(route, actions, false, [KBD.ENTER, KBD.PAGE_DOWN]);
    //     return cleanup;
    // }, []);

    const getRef = (key) => {
        if (!refs.current[key]) {
            refs.current[key] = { current: null }; // Create a ref object
        }
        return refs.current[key];
    };

    useEffect(() => { window.bm_state.value = route }, []);



    const idle_nav = [
        { key: KBD.PAGE_DOWN, action: () => !index && props.viewReport(false, false) },
        // { key: KBD.C, text: "Columns", action: () => !index && setIndex("columns") },
        { key: KBD.E, text: "Edit", action: () => !index && setIndex("name") },
        { key: KBD.F, text: "Filters", action: () => !index && setIndex("filter_all") },
        { key: KBD.I, text: "Index", action: () => !index && setIndex("order_1") },
        { key: KBD.V, text: "View", action: () => !index && props.viewReport(false, false) },
        { key: KBD.U, text: "Update", action: () => !index && props.updateReport(false, true) },
    ]


    const nav = (is_new) ? [] : [
        { key: KBD.ALT_C, inds: [0, 1, 2, 3, 4], text: "Alt+Columns", action: () => setIndex("columns") }
    ]

    const filters_nav = [
        { key: KBD.N, text: "New", action: () => kbdEvent(KBD.N) },
        { key: KBD.E, text: "Edit", action: () => kbdEvent(KBD.E) },
        { key: KBD.D, text: "Delete", action: () => kbdEvent(KBD.R) }
    ]


    const handleSave = (_tabs = tabs) => {

        const getV = key => _tabs.find(tab => tab.key === key)?.value;
        // remove all filters
        let _filters = edit.filters.filter(item => !([-6, -5, -1, -7].includes(item.type)));


   

        switch (getVal("scope_type")) {

            case 2:
                // Sales from period + Sales Types
                _filters.unshift({...getV("sales_in"), "value_dynamic" : ""});
                _filters.unshift({ ...FILTER, "type": -7, "where_type": "AND", value_1: getV("sales_types"), "value_dynamic" : "" })

                break;

            case 3:
                // Sales Invoice Range + Sales Types
                 _filters.unshift({...getV("invoices_between"), "value_dynamic" : ""});
                _filters.unshift({ ...FILTER, "type": -7, "where_type": "AND", value_1: getV("sales_types"), "value_dynamic" : "" })
            break;

            default:
                // Inventory - none
                break;
        }

        _filters = updateOrdering(_filters);


        pubCall("report.purgeAndReplaceFilters", { report_id: edit.report_id, filters_info: _filters, filter_where_type: "AND" }, (_s, _r) => {
            if (_s) {
                addReport();
                setReloadTrigger(!reloadTrigger)
            } else {
                showError(_r);
            }
        })


    }

    const handleEscape = (e, _ref = {}) => {

    
        if (is_new) {
            callback(false);
            return;
        }

        if (index) {
            if (typeof _ref?.blur === "function") {
                _ref.blur();
            }

            window.bm_state.value = route;
            // Reset name
            if (["name", "group"].includes(index)) {
                update("name", getDefaultValue("name"));
                update("group", getDefaultValue("group"));
            }


            // Reset scope
            if (["sales_in", "invoices_between", "inventory_between", "scope_type", "sales_types"].includes(index)) {
               
                update("sales_in", getDefaultValue("sales_in"));
                update("scope_type", getDefaultValue("scope_type"))
                update("invoices_between", getDefaultValue("invoices_between"))
                update("inventory_between", getDefaultValue("inventory_between"))
                update("sales_types", getDefaultValue("sales_types"))
              
            }

            // Reset Index
            if (["order_1", "order_2", "order_3"].includes(index)) {
                update("order_1", getDefaultValue("order_1"))
                update("order_2", getDefaultValue("order_2"))
                update("order_3", getDefaultValue("order_3"))
            }


            setIndex("");
        } else {
            callback(false);
        }


    }

    useEffect(() => {


        if(props?.loading){
            return; 
        }

        const el = refs?.current?.[index];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }

        if ((index !== "filter_none" && index !== "filter_one" && index !== "filter_all" && index !== "sales_types" && index !== "sales_in" && index !== "inventory_between" && index !== "invoices_between" && index !== "columns") && (window.bm_state.value !== route)) {

            if (window.bm_state.route === ROUTES.GLOBAL.REQUEST_CLERK_CODE) {
                return;
            }
            window.bm_state.value = route;
        }

        const actions = [
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
            {
                key: KBD.ESCAPE, action: (e) => {

                    handleEscape(e, el)


                }
            },
            {
                key: KBD.PAGE_DOWN, action: (e) => {
                    if (index) {
                        if (index === "scope_type") {
                            handleSave();
                            return;
                        }
                        updateOrderBy({})
                        addReport()
                    }
                }
            },

            // { key: KBD.ENTER, action: search },
        ];



        const cleanup = listen(controller, route, actions.concat(nav).concat(idle_nav), false, [KBD.ENTER, KBD.ESCAPE, KBD.TAB, KBD.SHIFT_ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ALT_C, KBD.PAGE_DOWN]);
        return cleanup;
    }, [index, tabs, edit, props?.loading]);



    const filterCallback = (_filters, _direction = "next", _group = "AND") => {
        // TODO deal with filters...
        if (_direction !== "prev") {
            next();
        } else {
            prev();
        }
    }


    const [reloadTrigger, setReloadTrigger] = useState(false);
    const updateOrderBy = (_orderbys) => {

        const { order_1 = getVal("order_1"), order_2 = getVal("order_2"), order_3 = getVal("order_3") } = _orderbys;



        pubCall("report.editOrderBys", { report_id: edit?.[row_key], order_1: order_1, order_2: order_2, order_3: order_3 }, (_s, _r) => {
            if (_s) {
                showMessage("Report parameters saved");
                setEdit(_r);
            }
        })
    }

    const drawGroups = (_value, _rowIndex) => {
        refs.current[index].blur();
        drawPicker({
            controller: controller,
            value: _value, title: "Select Group", closeable: true, height: 300, ref: refs.current[index], route: route, close: () => { refs.current[index].focus(); }, callback: (e) => {
                if (e) {
                    update("group", e)
                    addReport({ group: e });
                }
                refs.current[index].focus();


            }, offset: [0, 10],
            options: groups.map(item => {
                return {
                    label: item.name,
                    value: item.name
                }
            })
        })
    }

    const drawPresets = (_value, _rowIndex) => {
        refs.current[index].blur();
        drawPicker({
            controller: controller,
            value: _value, title: "Select Preset", closeable: true, height: 300, ref: refs.current["date_from"], route: route, close: () => { refs.current["date_from"].focus(); }, callback: (e) => {
                if (e) {
                    update("date_from", dayjs().format("YYYY-MM-DD"))
                }
                setTimeout(() => {
                    refs.current[index].focus();
                }, 100)



            }, offset: [0, 10],
            options: groups.map(item => {
                return {
                    label: item.name,
                    value: item.name
                }
            })
        })
    }

    const replaceTab = (tabs, key, newValue) => {
        return tabs.map(tab =>
            tab.key === key
                ? { ...tab, value: newValue }
                : tab
        );
    }


    return (
        <div className="controller component-layout">
            <Spin message="Generating report" loading={props.loading}>
                <div>
                    <div className="shim" />
                    <div style={{ "padding": "0px 5px" }}>
                        <FocusWrap message={<Status type="active"><InfoIcon />PgDn to save, Esc to cancel</Status>} active={(["name", "group"].includes(index))}>
                            <div className="shim" />
                            <div>
                                <Float>
                                    <Space>
                                        <Label width={50}>Name:</Label>
                                        <Input maxLength={50} {...editProps("name")} width={420} onEnter={() => next()} onClick={() => (index !== "name") && setIndex("name")} />
                                        <div>&nbsp;&nbsp;</div>
                                        <Label width={90}>Report Group:</Label>
                                        <Input doubleclick={(e) => drawGroups(e)} onPageUp={(e) => drawGroups(e)} maxLength={20} {...editProps("group")} onEnter={() => addReport()} width={200} onClick={() => (index !== "group") && setIndex("group")} />
                                    </Space>
                                    <Space>
                                        <Label>Last Updated:</Label> <div>{bm_date(edit?.date_changed)}, {bm_time(edit?.date_changed)}</div>
                                        <Label width={50}>Items:</Label> <div>{(edit?.cached_row_total) ? edit.cached_row_total : "Not run"}</div>
                                        <div style={{ "width": "5px" }}></div>
                                    </Space>
                                </Float>
                            </div>
                            <div className="shim" />
                        </FocusWrap>

                        <div className={(is_new) ? "disabled-area" : ""} style={{ filter: (is_new) ? "grayscale(100%)" : "", "opacity": (is_new) ? "0.5" : "1" }}>
                            <FocusWrap  nav={[
                                { key: KBD.ESCAPE, type: "back", text: "Back", action: () => kbdEvent(KBD.ESCAPE) },
                                { key: KBD.PAGE_DOWN, type: "save", text: "Save", action: () => kbdEvent(KBD.PAGE_DOWN) },
                            ]} active={(["sales_in", "invoices_between", "inventory_between", "scope_type", "sales_types"].includes(index))}>
                                <div style={{ "height": "83px", display: "flex" }}>
                                    <Float>

                                    {(index === "" && <div style={{"padding" : "20px"}}><Button onClick={() => kbdEvent(KBD.U)} type="primary">Update and View</Button></div>)}
                                    </Float>

                                </div>
                                <div className="shim" />
                            </FocusWrap>
                            <div className="shim" />

                            <div style={{ "minHeight": "200px", "height": "calc(100vh - 630px)" }}>
                                <div ref={filter_clickaway} style={{ display: "flex", width: "100%", "height": "100%" }}>

                                    <div style={{ flex: 1, padding: "0px 10px", boxSizing: "border-box" }}>
                                        <FocusWrap cancelText="Done" save={false} mask={false} active={(["filter_all"].includes(index))}>
                                            <CustomerFilter controller={controller} activate={() => setIndex("filter_all")} height={0} goto={(e) => { (e === "save") ? addReport() : setIndex("columns") }} data={edit?.filters?.filter(item => item.type > -1 && item.where_type === "AND")} show_add route={ROUTES.CUSTOMER.FILTER} {...editProps("filter_all")} escape={() => setIndex("")} report={edit} setReport={setEdit} callback={(e, d) => filterCallback(e, d)} where_type="AND" header="All of (Must/All)" headerClass="dark-green" showColumnHeaders={false} edit={(index === "filter_all")} />
                                        </FocusWrap>
                                    </div>

                                    <div style={{ flex: 1, padding: "0px 10px", boxSizing: "border-box" }}>
                                        <FocusWrap cancelText="Done" save={false} mask={false} active={(["filter_one"].includes(index))}>
                                            <CustomerFilter controller={controller} activate={() => setIndex("filter_one")} height={0} goto={(e) => { (e === "save") ? addReport() : setIndex("columns") }} data={edit?.filters?.filter(item => item.type > -1 && item.where_type === "OR")} show_add route={ROUTES.CUSTOMER.FILTER} {...editProps("filter_one")} escape={() => setIndex("")} report={edit} setReport={setEdit} callback={(e, d) => filterCallback(e, d)} where_type="OR" header="One of (Include/Any)" headerClass="dark-orange" showColumnHeaders={false} edit={(index === "filter_one")} />
                                        </FocusWrap>
                                    </div>

                                    <div style={{ flex: 1, padding: "0px 10px", boxSizing: "border-box" }}>
                                        <FocusWrap cancelText="Done" save={false} mask={false} active={(["filter_none"].includes(index))}>
                                            <CustomerFilter controller={controller} activate={() => setIndex("filter_none")} height={0} goto={(e) => { (e === "save") ? addReport() : setIndex("columns") }} data={edit?.filters?.filter(item => item.type > -1 && item.where_type === "NOT")} show_add route={ROUTES.CUSTOMER.FILTER} {...editProps("filter_none")} escape={() => setIndex("")} report={edit} setReport={setEdit} callback={(e, d) => filterCallback(e, d)} where_type="NOT" header="None of (Exclude)" headerClass="dark-red" showColumnHeaders={false} edit={(index === "filter_none")} />
                                        </FocusWrap>
                                    </div>


                                </div>
                            </div>

                            <FocusWrap active={(["order_1", "order_2", "order_3"].includes(index))}>
                                <div style={{ "padding": "10px 15px" }}>
                                    <Space>
                                        <Label width={55}><nobr>Index by:</nobr></Label>
                                        <Select
                                            controller={controller}
                                            number
                                            {...editProps("order_1")}

                                            offset={[-40, 0]}
                                            align="bottom"
                                            autocomplete
                                            top={true}
                                            title="Select Index"
                                            options={ENUMS.CUSTOMER_INDEX.filter(item => item.value !== 0).sort((a, b) => a.label.localeCompare(b.label))}
                                            placeholder="Select index"
                                            returnRoute={route}
                                            onSelect={(e) => setTimeout(() => { setIndex("order_2") }, 0)}
                                            onNext={() => { setTimeout(() => { setIndex("order_2") }, 0) }}
                                            onPrev={() => { setTimeout(() => { setIndex("") }, 0) }}
                                            onClick={() => (index !== "order_1") && setIndex("order_1")}
                                        />
                                        <Label>then</Label>
                                        <Select
                                            controller={controller}
                                            number
                                            {...editProps("order_2")}
                                            //onChange={(val) => setV(val)}
                                            offset={[-40, 0]}
                                            align="bottom"
                                            autocomplete
                                            title="Select Index"
                                            options={[{ value: 0, label: "None" }].concat(ENUMS.CUSTOMER_INDEX.filter(item => item.value !== 0).sort((a, b) => a.label.localeCompare(b.label)))}
                                            placeholder="Select index..."
                                            returnRoute={route}
                                            onSelect={(e) => setTimeout(() => {
                                                if (!e) {

                                                    updateOrderBy({ order_2: 0, order_3: 0 });
                                                    update("order_3", 0);
                                                    setIndex("")


                                                } else { setIndex("order_3"); }
                                            }, 0)}
                                            onNext={() => { setTimeout(() => { setIndex("order_3") }, 0) }}
                                            onPrev={() => { setTimeout(() => { setIndex("order_1") }, 0) }}
                                            onClick={() => (index !== "order_2") && setIndex("order_2")}
                                        />
                                        <Label>then</Label>
                                        <Select
                                            controller={controller}
                                            number
                                            {...editProps("order_3")}
                                            //onChange={(val) => setV(val)}
                                            title="Select Index"
                                            offset={[-40, 0]}
                                            align="bottom"
                                            autocomplete
                                            options={[{ value: 0, label: "None" }].concat(ENUMS.CUSTOMER_INDEX.filter(item => item.value !== 0).sort((a, b) => a.label.localeCompare(b.label)))}
                                            placeholder="Select index..."
                                            returnRoute={route}
                                            onSelect={(e) => setTimeout(() => {
                                                updateOrderBy({ order_3: e });
                                                setIndex("")
                                            }, 0)}
                                            onPrev={() => { setTimeout(() => { setIndex("order_2") }, 0) }}
                                            onClick={() => (index !== "order_3") && setIndex("order_3")}
                                        />
                                    </Space>
                                </div>
                            </FocusWrap>

                            <div style={{ "padding": "0px 15px" }}>
                                <Float>
                                    <Space>
                                        <Label style={{ "textAlign": "left" }}>Preview <em><small>(First 10 matches only - view updated report for most recent data)</small></em>&nbsp;&nbsp;<em>
                                        </em></Label>

                                    </Space>
                                </Float>

                                <div className="no-focus" style={{ maxWidth: "100%", "height": "calc(100vh - 550px)", "maxHeight": "280px", "minHeight": "75px" }}>
                                    <div className="no-focus" style={{ display: "flex", flexWrap: "nowrap", "height": "100%", "maxHeight": "280px" }} >
                                        <div ref={filter_clickaway3} className="no-focus" style={{ flex: "1 1 0", maxWidth: "100%", width: "100%", minWidth: "0", "maxHeight": "280px" }}>
                                            <CustomerColumns
                                                columnsChanged={columnsChanged}
                                                setColumnsChanged={setColumnsChanged}
                                                controller={controller}
                                                is_new={is_new}
                                                columnView={false}
                                                reloadTrigger={reloadTrigger}
                                                report={edit}
                                                setReport={setEdit}
                                                escape={() => setIndex("")}
                                                route={ROUTES.REPORTS.COLUMNS}
                                                {...editProps("columns")}
                                                edit={index === "columns"}
                                            />
                                        </div>
                                        <div style={{ flex: "0 0 0" }}></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Spin>

            <div className="flex-bottom">
                <div className="shim" />
                <Divider />
                <div className="nav-wrapper">
                    <Space style={{ padding: "0px 15px" }}>
                        {(index === "filter_none" || index === "filter_one" || index === "filter_all") && <Nav nav={filters_nav} />}
                        {((index !== "columns" && index !== "filter_none" && index !== "filter_one" && index !== "filter_all") && <Nav nav={(index) ? nav : idle_nav} />)}
                    </Space>
                </div>
            </div>

        </div>
    )
}